import {InjectionToken} from '@angular/core';

export const REX_DEBUG_MESSAGES = new InjectionToken<boolean>('REX_DEBUG_MESSAGES');
